import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  'emptyLicenseTypeLabel': {
    id: 'license.activationPanel.emptyLicenseTypeLabel',
    description: 'Label for empty-option in license type selector.',
    defaultMessage: 'Choose license type',
  },
  'emptySellerLabel': {
    id: 'license.activationPanel.emptySellerLabel',
    description: 'Label for empty-option in seller selector.',
    defaultMessage: 'Choose seller',
  },
  'licenseLengthHelpText': {
    id: 'license.activationPanel.helptext.length',
    description: 'License length info',
    defaultMessage: 'Period is {periodInMonths} months',
  },
  'licenseExtraMonthsHelpText': {
    id: 'license.activationPanel.helptext.extraMonths',
    description: 'License extra months info',
    defaultMessage: 'Extra months are applied only to the first billing period of the license.'
  },
  'licenseEndDateContinuousHelpText': {
    id: 'license.activationPanel.helptext.endDate-continous',
    description: 'License end date info for continous license',
    defaultMessage: 'End date for the first billing period (continous license).'
  },
  'licenseEndDateExtraMonthsHelpText': {
    id: 'license.activationPanel.helptext.endDate-extraMonths',
    description: 'License end date info for extra months',
    defaultMessage: 'The first billing period contains {extraMonths} extra month(s).'
  },
  'licensePriceActivationHelpText': {
    id: 'license.activationPanel.activation.helptext.price',
    description: 'License price info for activation',
    defaultMessage: 'Price is between {minPrice} and {maxPrice} euros',
  },
  'licensePriceUpgradeHelpText': {
    id: 'license.activationPanel.upgrade.helptext.price',
    description: 'License price info for upgrade',
    defaultMessage: 'License price is {rrp} euros and compensation {compensation} euros',
  },
  'activationAction': {
    id: 'license.activationPanel.button.activate.label',
    description: 'New license activation button label',
    defaultMessage: 'Activate',
  },
  'upgradeAction': {
    id: 'license.activationPanel.button.upgrade.label',
    description: 'Current license upgrade button label',
    defaultMessage: 'Upgrade',
  },
  'cancellationAction': {
    id: 'license.activationPanel.button.cancel.label',
    description: 'New license activation cancellation button label',
    defaultMessage: 'Cancel',
  },
  'licenseContinuousHelpText': {
    id: 'license.activationPanel.helptext.continuous',
    description: 'License continuous helptext',
    defaultMessage: 'Should the license be automatically renewed et the end of period?',
  }
});
